/* Web-Push helpers — register SW, subscribe/unsubscribe, check state. */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;
}

export function pushPermission() {
  if (!pushSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready.catch(() => null);
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

async function ensureSW() {
  if (!pushSupported()) throw new Error("Push nicht unterstützt");
  const reg = await navigator.serviceWorker.register("/push-sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  return reg;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Push nicht unterstützt");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Berechtigung verweigert");
  const { data } = await axios.get(`${API}/push/config`, { withCredentials: true });
  if (!data.public_key) throw new Error("VAPID-Key fehlt");
  const reg = await ensureSW();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await axios.post(`${API}/push/subscribe`, {
    endpoint: json.endpoint,
    keys: json.keys,
    user_agent: navigator.userAgent,
  }, { withCredentials: true });
  return sub;
}

export async function disablePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  const endpoint = sub.endpoint;
  await axios.delete(`${API}/push/subscribe`, { data: { endpoint }, withCredentials: true });
  try { await sub.unsubscribe(); } catch (e) {
    if (process.env.NODE_ENV !== "production") console.debug("[push] unsubscribe failed:", e?.message);
  }
}

export async function sendTestPush() {
  await axios.post(`${API}/push/test`, {}, { withCredentials: true });
}
